<template>
  <div class="container">
    <div class="top-header d-none d-lg-block">
      <span>{{ $t('welcome_user', { username: name }) }}</span>
      <span class="divider">|</span>
      <div class="dropdown">
        <span class="dropbtn">{{ selectedLocale.toUpperCase() }} &#709;</span>
        <div class="dropdown-content">
          <a v-on:click="changeLanguage('en')" v-if="'en' != selectedLocale">EN</a>
          <a v-on:click="changeLanguage('fr')" v-if="'fr' != selectedLocale">FR</a>
          <a v-on:click="changeLanguage('nl')" v-if="'nl' != selectedLocale">NL</a>
        </div>
      </div>
      <span class="divider" v-if="sharepointUrl">|</span>
      <span class="top-header-logout" v-if="sharepointUrl">
        <a class="link" :href="sharepointUrl" target="_blank">Document Portal</a>
      </span>
      <span class="divider" v-if="isAdmin">|</span>
      <span class="top-header-logout" v-if="isAdmin" v-on:click="goToAdmin()">Admin</span>
      <span class="divider" v-if="isAdmin">|</span>
      <span class="top-header-logout" v-if="isAdmin" v-on:click="goToDashboard()">Dashboard</span>
      <span class="divider">|</span>
      <span class="top-header-logout" v-on:click="logout()">{{ $t("logout") }}</span>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="navbar-brand" href="#" style="position: relative;">
        <router-link to="/main/selection">
          <img v-bind:src="image" alt="Duomed" />
        </router-link>

        <span
          v-show="licenseExpired"
          style="color: #dc3545; position: absolute; left: 73px; bottom: -8px; font-size: 16px;"
        >{{ $t('license_expired_2') }}</span>
      </div>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo01"
        aria-controls="navbarTogglerDemo01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0"></ul>

        <ul class="navbar-nav my-2 my-lg-0" v-if="showMenu">
          <li class="nav-item" v-if="isService">
            <router-link
              class="nav-link"
              active-class="nav-active"
              to="/main/service-objects"
            >{{ $t("service_objects") }}</router-link>
          </li>

          <li class="nav-item" v-if="isService">
            <router-link
              class="nav-link"
              active-class="nav-active"
              to="/main/service-contracts"
            >{{ $t("service_contracts") }}</router-link>
          </li>

          <li class="nav-item" v-if="isService">
            <router-link
              class="nav-link"
              active-class="nav-active"
              to="/main/service-calls"
            >{{ $t("service_calls_general") }}</router-link>
          </li>

          <li class="nav-item" v-if="isInvoice">
            <router-link
                class="nav-link"
                active-class="nav-active"
                to="/main/invoices"
            >{{ $t("invoices") }}</router-link>
          </li>
        </ul>
      </div>
    </nav>

    <div class="test-overlay" v-if="!isProduction">{{ environment }} omgeving</div>
  </div>
</template>

<script>
import { user } from './../../user.js';
import { bus } from './../../main.js';

let showMenu = true;

export default {
  name: 'Header',
  beforeCreate: function() {},
  created: function() {
    let currentRoute = this.$router.currentRoute.name;

    if (currentRoute === 'selection') {
      hideMenuAndSharepoint(this);
    } else {
      showMenuAndSharepoint(this);
    }

    this.isProduction = process.env.VUE_APP_ENVIRONMENT === 'production';

    updateLogo(this);

    getUserInfo(this);
  },
  methods: {
    logout: function() {
      if (confirm(this.$t('confirm_logout'))) {
        user.signOut();
      }
    },
    changeLanguage: function(locale) {
      this.$i18n.locale = locale;
      this.selectedLocale = locale;

      this.$cookie.set('selectedLocale', locale, { expires: '1Y' });

      bus.$emit('languageChanged');
    },
    goToAdmin: function() {
      this.$router.push({
        name: 'admin'
      });
    },
    goToDashboard: function() {
      this.$router.push({
        name: 'dashboard'
      });
    }
  },
  data: function() {
    return {
      name: user.userName,
      selectedLocale: this.$i18n.locale,
      showMenu: showMenu,
      image: 'logo.png',
      user: user,
      company: null,
      sharepointUrl: null,
      isAdmin: false,
      isProduction: false,
      environment: process.env.VUE_APP_ENVIRONMENT,
      licenseExpired: false,
      isInvoice: false,
      isService: false,
    };
  },
  watch: {
    $route(to, from) {
      updateLogo(this);
      
      getUserInfo(this);

      if (
        to.name === 'selection' ||
        to.name === 'admin' ||
        to.name === 'dashboard'
      ) {
        hideMenuAndSharepoint(this);
      } else {
        showMenuAndSharepoint(this);
      }
    }
  }
};

function getCompany(context, companyId) {
  let promise = context.$axios.get('selection/getcompany?companyId=' + companyId);

  return promise
    .then(data => {
      const item = data.data;

      context.company = item;
      context.sharepointUrl = item.sharepointUrl;
    })
    .catch(error => {
      console.log(error);
    });
}

function getUserInfo(context) {
  let promise = context.$axios.get('systemsettings/userinfo');

  return promise
    .then(data => {
      const logins = data.data;

      if (logins && logins.length > 0) {
        logins.forEach(login => {
          if (login.roleId === 3) {
            context.isAdmin = true;
          }

          if (login.roleId !== 1) {
            context.isInvoice = true;
          }

          if (login.roleId !== 4) {
            context.isService = true;
          }

        });
      }
    })
    .catch(error => {
      console.log(error);
    });
}

function showMenuAndSharepoint(context) {
  context.showMenu = true;

  if (context.company == null) {
    let companyId = context.$cookie.get('companyId');

    getCompany(context, companyId);
  }
}

function hideMenuAndSharepoint(context) {
  context.showMenu = false;

  context.company = null;
  context.sharepointUrl = null;
}

function updateLogo(context) {
  context.licenseExpired = false;

  let path = context.$cookie.get('companyId');

  if (path == null) {
    setLogo(context, '/logo.png');
  } else {
    setLogo(context, '/' + path.toUpperCase() + '.png');

    let licenseExpired = context.$cookie.get('licenseExpired');
    if (licenseExpired === 'true') {
      context.licenseExpired = true;
    }
  }
}

function setLogo(context, url) {
  if (context.image !== url) {
    context.image = url;
  }
}
</script>

<style scoped>
.nav-item a {
  font-size: 1.1rem;
  padding: 8px 0;
  color: #18385f !important;
}

.top-header {
  text-align: right;
  font-size: 14px;
  color: #93a1b2;
  padding-right: 1rem;
  padding-top: 15px;
}

.top-header .link {
  color: #93a1b2;
}

.top-header .link:hover {
  text-decoration: none;
  color: #18385f;
}

.top-header .divider {
  padding: 0 15px;
}

.top-header-logout {
  cursor: pointer;
}

.top-header-logout:hover {
  color: #18385f;
}

.navbar {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}

.navbar-brand img {
  height: 65px;
}

@media (min-width: 992px) {
  .nav-item {
    border-bottom: 1px solid white;
    margin: 0 8px;
  }

  .nav-active {
    border-bottom: 1px solid #00a385;
    color: #00a385 !important;
  }
}

.dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.dropdown-content {
  left: -14px;
  text-align: center;
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 60px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.test-overlay {
  position: absolute;
  top: 15px;
  background-color: lightgoldenrodyellow;
  border: 1px solid #18385f;
  padding: 0 15px;
  text-transform: capitalize;
}
</style>
